import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface ResponseAddTestState {
    success: boolean;
    questionId: string | number
}

const initialState: ResponseAddTestState = {
    success: false,
    questionId: 0,
};

const deleteFileSlice = createSlice({
    name: "deleteFile",
    initialState,
    reducers: {
        setDeleteFile: (state, action: PayloadAction<ResponseAddTestState>) => {
            state.success = action.payload.success;
            state.questionId = action.payload.questionId
        },
        resetDeleteFile: (state) => {
            state.success = false;
        },
    },
});


export const {setDeleteFile, resetDeleteFile} = deleteFileSlice.actions;

export const deleteFileSliceReducer = deleteFileSlice.reducer;

